export const ExportIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      className={className}
      fill="none"
    >
      <path
        d="M10.961 5.93359C13.361 6.14026 14.341 7.3736 14.341 10.0736V10.1603C14.341 13.1403 13.1476 14.3336 10.1676 14.3336H5.82764C2.84763 14.3336 1.6543 13.1403 1.6543 10.1603V10.0736C1.6543 7.3936 2.62096 6.16026 4.98097 5.94026"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10.0007V2.41406"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2343 3.90131L8.00092 1.66797L5.76758 3.90131"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
